/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Seo_Rate_AsinsInputs */

const en_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} per 1,000 asins`)
};

const zh_hans1_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每千个 ASIN ${i?.rate}`)
};

const pt_br2_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por mil ASINs`)
};

const es_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por cada 1,000 ASIN`)
};

const fr_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pour 1 000 asins`)
};

const de_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pro 1.000 ASINs`)
};

const ru_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} за 1000 ASIN`)
};

const it_seo_rate_asins = /** @type {(inputs: Seo_Rate_AsinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} ogni 1.000 ASIN`)
};

/**
* | output |
* | --- |
* | "{rate} per 1,000 asins" |
*
* @param {Seo_Rate_AsinsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_rate_asins = /** @type {((inputs: Seo_Rate_AsinsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Rate_AsinsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_rate_asins(inputs)
	if (locale === "pt-BR") return pt_br2_seo_rate_asins(inputs)
	if (locale === "es") return es_seo_rate_asins(inputs)
	if (locale === "fr") return fr_seo_rate_asins(inputs)
	if (locale === "de") return de_seo_rate_asins(inputs)
	if (locale === "ru") return ru_seo_rate_asins(inputs)
	if (locale === "it") return it_seo_rate_asins(inputs)
	return en_seo_rate_asins(inputs)
});